
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.273 1.889H3v12.545h10.273V1.889z","stroke":"#8F7A61","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.2 10.163a.842.842 0 00-.238-.615c-.158-.164-.422-.31-.791-.44a6.372 6.372 0 01-.861-.364c-.683-.366-1.024-.908-1.024-1.626 0-.486.148-.886.443-1.2.296-.313.698-.5 1.205-.558v-.958h.703v.967c.51.073.904.29 1.182.65.278.358.417.824.417 1.398H9.173c0-.37-.084-.66-.25-.87a.802.802 0 00-.673-.321c-.281 0-.501.076-.66.228-.157.153-.236.371-.236.655 0 .255.077.46.232.615.159.153.425.298.8.435.375.138.67.266.884.383.213.117.394.252.54.404.147.15.26.322.338.519.08.196.12.426.12.69 0 .495-.153.896-.458 1.204-.302.307-.724.489-1.266.545v.857h-.698v-.853c-.58-.064-1.027-.272-1.34-.624-.311-.352-.466-.817-.466-1.398h1.067c0 .37.093.655.277.857.188.203.451.304.791.304.334 0 .588-.08.76-.242a.829.829 0 00.264-.642z","fill":"#8F7A61"}})])
          )
        }
      }
    